import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";

import MUIDataTable from "mui-datatables";

// components
import PageTitle from "../../components/PageTitle/PageTitle";

// data
import {BranchList} from "./branchesList-api"

//auth
import auth from "../../auth/auth-helper";

const columns = [
  {
   name: "branch_name",
   label: "Branch Name",
   options: {
    filter: true,
    sort: true,
   }
  },
  {
   name: "location",
   label: "Location",
  },
  {
    name: "status",
    label: "Status",
    options: {
     filter: true,
     sort: false,
    }
   },
  {
   name: "branch_id",
   label: "ID",
   options: {
    filter: true,
    sort: false,
   }
  },
 
 ];

export default function Branches() {
  const [branches, setBranches] = useState([]);

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;
    const credentials = auth.isAuthenticated();

    BranchList(signal,credentials).then((res) => {
      if (res.status === 200) {
        // console.log('token here .....................'+ credentials);
        // console.log(res.status);
        console.log(res);
        //console.log(res.statusCode);
        setBranches(res.response[0]);
      } else {
       
      }
     
    });

    return function cleanup() {
      abortController.abort();
    };
  }, []);
  return (
    <>
      <PageTitle title="Branches" />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <MUIDataTable
            title="Branches List"
            data={branches}
            columns={columns}
            options={{
              filterType: "checkbox",
            }}
          />
        </Grid>
        {/* <Grid item xs={12}>
          <Widget title="Material-UI Table" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
            <Table data={mock.table} />
          </Widget>
        </Grid> */}
      </Grid>
    </>
  );
}